import { useSelector } from 'react-redux';
import { NotificationList } from './NotificationList';


export const NotificationModal = ()=>{
    const notificationModal = useSelector(state => state.notificationModal);
    const auth = useSelector(state => state.auth);

    if(!notificationModal.open)return null;
    if(!auth.authenticated )return null;

    return <NotificationList />;
};
